
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsx mdx */
import { themes, Image } from 'mdx-deck'
import Human from './components/Human';
import Crumb from './components/Crumb';
export const theme = themes.swiss;
const browserSequence = "https://raw.githubusercontent.com/johncalvinroberts/wasm-talk/dev/assets/browser.svg";
const buildSequence = "https://raw.githubusercontent.com/johncalvinroberts/wasm-talk/dev/assets/build.svg";
const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope")
  return <div {...props}/>
};
const Steps = makeShortcode("Steps");
const Notes = makeShortcode("Notes");
const layoutProps = {
  theme
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h1>{`Web Assembly for Dumb People`}</h1>
    <p>{`A tool for running native code on the web.`}</p>
    <Steps mdxType="Steps">
      <p>{`  By John`}</p>
    </Steps>
    <Notes mdxType="Notes">
  - Very rough web assembly intro: a new thing, a tool for running native code in a browser
  - The scope of this talk - DUMB PEOPLE. Meaning me, not you guys.
    </Notes>
    <hr></hr>
    <h1>{`Dumb People?`}</h1>
    <Human mdxType="Human">This will be a presentation full of gross oversimplifications. The goal is to highlight practical (real world) applications of Web Assembly.<br />
When you see a Donald Trump, that means a key dumb person takeaway is being communicated.</Human>
    <Notes mdxType="Notes">
      <ul>
        <li parentName="ul">{`When you see the dumb person, that's a key takeaway.`}</li>
        <li parentName="ul">{`What (in my eyes) is web assembly`}</li>
        <li parentName="ul">{`What are the benefits + a quick demo.`}</li>
        <li parentName="ul">{`What is it good for`}</li>
        <li parentName="ul">{`What is it `}<strong parentName="li">{`not`}</strong>{` good for`}</li>
        <li parentName="ul">{`Practical, not flashy use cases`}</li>
        <li parentName="ul">{`Architecture and workflow`}</li>
        <li parentName="ul">{`Demo pprmnt  `}</li>
      </ul>
    </Notes>
    <hr></hr>
    <h1>{`00. What the heck is a WASM?`}</h1>
    <Crumb mdxType="Crumb"> 00. What the heck is a WASM?</Crumb>
    <Steps mdxType="Steps">
      <ul>
        <li parentName="ul">{`WASM = Web Assembly`}</li>
        <li parentName="ul">{`"A tool for running native code on the web" -- What does that mean?`}</li>
        <li parentName="ul">{`How do browsers work? `}</li>
        <li parentName="ul">{`What is native code?`}</li>
        <li parentName="ul">{`Bundle native code and run it in the browser`}</li>
        <li parentName="ul">{`WASM runs alongside javascript, not instead of or within it.`}</li>
        <li parentName="ul">{`Really, it's a compile target.`}</li>
      </ul>
    </Steps>
    <Notes mdxType="Notes">
      <ul>
        <li parentName="ul">{`How do browsers work? The runtime language of the browser is Javascript`}</li>
        <li parentName="ul">{`Native code means basically assembly, binary formats that your operating system understands "natively"`}</li>
        <li parentName="ul">{`What we actually want to focus on is WASM as a compile target for C++, C, Rust, etc.`}</li>
        <li parentName="ul">{`Low-level systems languages that utilize native features, memory management, blah blah. too complicated`}</li>
      </ul>
    </Notes>
    <hr></hr>
    <Crumb mdxType="Crumb"> 00. What the heck is a WASM?</Crumb>
    <Human mdxType="Human">In other words, to me it is a <strong>tool</strong>. <br />
It's not a language, a runtime, nor an API. It's a tool that lets me run native code on the web.</Human>
    <hr></hr>
    <h1>{`01. What are the benefits of using WASM?`}</h1>
    <Crumb mdxType="Crumb"> 01. What are the benefits of using WASM?</Crumb>
    <p>{`Why would I want to run native code in a browser?`}</p>
    <Steps mdxType="Steps">
      <ul>
        <li parentName="ul">{`Performance`}</li>
        <li parentName="ul">{`Utilize native code`}</li>
        <li parentName="ul">{`Security`}</li>
        <li parentName="ul">{`Combining the above 3 points with specific, sharp use cases.`}</li>
        <li parentName="ul">{`Reminder: `}<strong parentName="li">{`completely client side in the browser`}</strong>{`.  `}</li>
      </ul>
    </Steps>
    <Notes mdxType="Notes">
      <ul>
        <li parentName="ul">{`Performance -- it is faster than javascript, by a lot. I don't understand why exactly but it just is.`}</li>
        <li parentName="ul">{`Utilize native code - you can use other people's C/C++/Rust code. Great, less code.`}</li>
        <li parentName="ul">{`Security - compiled code is immutable and not observable at runtime, WebAssembly programs are protected from control flow hijacking attacks.`}</li>
        <li parentName="ul">{`Low-level systems languages that utilize native features, memory management, blah blah. too complicated`}</li>
        <li parentName="ul">{`Reminder: `}<strong parentName="li">{`completely client side in the browser`}</strong>{`.  No server. Privacy. Etc.`}</li>
      </ul>
    </Notes>
    <hr></hr>
    <Crumb mdxType="Crumb"> 01. What are the benefits of using WASM?</Crumb>
    <Human mdxType="Human">
  Let's compare fibonacci sequence executing in WASM and JS
  <div>
    <a href="https://fib.johnny.sh/">Live demo</a>
  </div>
  <div>
    <a href="https://github.com/johncalvinroberts/fib-demo">Source code</a>
  </div>
    </Human>
    <Notes mdxType="Notes">
      <ul>
        <li parentName="ul">{`Fibonacci sequence, also known as the Golden Ratio, appears a lot in nature. `}</li>
        <li parentName="ul">{`This is the recursive implementation, an algorithm of exponential time complexity, which means the execution time doubles with each new data point.`}</li>
      </ul>
    </Notes>
    <hr></hr>
    <h1>{`02. What is WASM good for?`}</h1>
    <Crumb mdxType="Crumb"> 02. What is WASM good for?</Crumb>
    <Steps mdxType="Steps">
      <ul>
        <li parentName="ul">{`Javascript is "fast enough".`}</li>
        <li parentName="ul">{`We have to ask: what can we `}<strong parentName="li">{`not`}</strong>{` do in a browser/javascript?`}</li>
      </ul>
    </Steps>
    <Notes mdxType="Notes">
      <ul>
        <li parentName="ul">{`For the most part, Javascript is "fast enough". We don't often run into serious runtime bottlenecks with Javascript. `}</li>
        <li parentName="ul">{`To figure this out what is WASM good for, we have to ask: what can we not do in a browser/javascript?`}</li>
      </ul>
    </Notes>
    <hr></hr>
    <h1>{`02. What is WASM good for?`}</h1>
    <Crumb mdxType="Crumb"> 02. What is WASM good for?</Crumb>
    <Steps mdxType="Steps">
      <ul>
        <li parentName="ul">{`Image & audio manipulation`}</li>
        <li parentName="ul">{`File encoding/decoding`}</li>
        <li parentName="ul">{`Cryptography`}</li>
        <li parentName="ul">{`Heavy, performance-critical computations (fibonacci example).`}</li>
        <li parentName="ul">{`Memory-safe computation/security`}<ul parentName="li">
            <li parentName="ul">{`compiled code is immutable and not observable at runtime, WebAssembly programs are protected from control flow hijacking attacks. `}<a parentName="li" {...{
                "href": "https://webassembly.org/docs/security/"
              }}>{`link`}</a></li>
          </ul></li>
        <li parentName="ul">{`Reminder: `}<strong parentName="li">{`completely client side in the browser`}</strong>{`.  `}</li>
      </ul>
    </Steps>
    <hr></hr>
    <Crumb mdxType="Crumb">02. What is WASM good for?</Crumb>
    <Human mdxType="Human">
  There's a sweet spot for WASM — memory-intensive, performance-critical tasks, that might need to do native-y stuff. <br />
  You'll know when you need it.
    </Human>
    <hr></hr>
    <Crumb mdxType="Crumb">02. What is WASM good for?</Crumb>
    <h3>{`For the not dumb people`}</h3>
    <p><a parentName="p" {...{
        "href": "https://webassembly.org/docs/use-cases/"
      }}>{`official docs`}</a>{` - How WebAssembly can be used`}</p>
    <hr></hr>
    <Crumb mdxType="Crumb">03. What is WASM not good for?</Crumb>
    <h1>{`03. What is WASM not good for?`}</h1>
    <Steps mdxType="Steps">
      <ul>
        <li parentName="ul">{`Typical browser stuff`}</li>
        <li parentName="ul">{`Rendering DOM nodes`}</li>
        <li parentName="ul">{`Web pages`}</li>
        <li parentName="ul">{`network i/o`}</li>
        <li parentName="ul">{`Making the buttons "pop"🌈🌈🌈`}</li>
      </ul>
    </Steps>
    <Notes mdxType="Notes">
      <ul>
        <li parentName="ul">{`Rendering dom nodes — the browser is already REALLLYYY good for that.`}</li>
        <li parentName="ul">{`Frameworks that do that with rust/wasm -- they're just calculating layouts and reconciling dom state inside of wasm, seems pointless.`}</li>
        <li parentName="ul">{`You CAN make user interfaces in it, you can make games with it, but that's definitely not for dumb people.`}</li>
      </ul>
    </Notes>
    <hr></hr>
    <Crumb mdxType="Crumb">03. What is WASM not good for?</Crumb>
    <Human mdxType="Human">
  Typical things you would do in a browser or Javascript are not being replaced by WASM.
    </Human>
    <Notes mdxType="Notes">
      <ul>
        <li parentName="ul">{`It's not necessarily a silver bullet that is going to make your web app 20x faster`}</li>
      </ul>
    </Notes>
    <hr></hr>
    <Crumb mdxType="Crumb">04. Practical, not flashy case studies</Crumb>
    <h1>{`04. Practical, not flashy case studies`}</h1>
    <Steps mdxType="Steps">
      <ul>
        <li parentName="ul"><a parentName="li" {...{
            "href": "https://squoosh.app/"
          }}>{`Squoosh`}</a>{` - Image manipulation`}</li>
        <li parentName="ul"><a parentName="li" {...{
            "href": "https://cyph.app/"
          }}>{`Cyph`}</a>{` - Cryptography`}</li>
        <li parentName="ul"><a parentName="li" {...{
            "href": "https://github.com/drbh/wasm-flate"
          }}>{`wasm-flate`}</a>{` - File compression/decompression`}</li>
        <li parentName="ul">{`Figma - Image manipulation X 1000000`}</li>
        <li parentName="ul">{`Normal web tech with WASM sprinkled on top as turbo-boosters`}</li>
      </ul>
    </Steps>
    <hr></hr>
    <Crumb mdxType="Crumb">04. Practical, not flashy case studies</Crumb>
    <Human mdxType="Human">
  Small, sharp tools. <br />
  Normal web tech with WASM sprinkled on top as turbo-boosters.
    </Human>
    <Notes mdxType="Notes">
  
  - At least for me, for dumb people, this is the real practical use case for web assembly.
  - Most of the apps we're seeing using WASM in the wild are following this architecture -- normal web apps, using WASM for small sharp tools.
  - Figma, at the end of the day, is a React app. There are more sprinkles than other apps, yes, but it is following this pattern.
  - So...react app you say...it can't be that hard.
    </Notes>
    <hr></hr>
    <img src="https://user-images.githubusercontent.com/11850362/80774995-00504200-8b91-11ea-8e4f-1673ca04c4c3.png" />
    <hr></hr>
    <Crumb mdxType="Crumb">05. Architecture case study - pprmnt.cc</Crumb>
    <h1>{`05. Architecture case study - pprmnt.cc`}</h1>
    <Steps mdxType="Steps">
      <ul>
        <li parentName="ul">{`My own small sharp tool 🥰`}</li>
        <li parentName="ul">{`Inspired largely by the aforementioned `}<a parentName="li" {...{
            "href": "https://squoosh.app/"
          }}>{`Squoosh`}</a></li>
        <li parentName="ul">{`An MP3 encoder in the browser, powered by Web Assembly.`}</li>
      </ul>
    </Steps>
    <Notes mdxType="Notes">
      <ul>
        <li parentName="ul">{`On topic of small sharp tools, and web assembly, I did find myself in a situation where "you know when you need it".`}</li>
        <li parentName="ul">{`Inspired by Squoosh in its architecture -- a small React app, utilizing classic codecs to encode files.`}</li>
        <li parentName="ul">{`Yes, there are tons of MP3 converters out there in the world, but they are sketchy.`}</li>
        <li parentName="ul">{`I am often dealing with lossless audio, and want to create lightweight lossy version without having to upload to sketchy third party servers.`}</li>
      </ul>
    </Notes>
    <hr></hr>
    <Crumb mdxType="Crumb">05. Architecture case study - pprmnt.cc</Crumb>
    <Human mdxType="Human">
  pprmnt.cc - an MP3 encoder in WASM
  <div>
    <a href="https://pprmnt.cc/">Live demo</a>
  </div>
  <div>
    <a href="https://github.com/johncalvinroberts/pprmnt">Source code</a>
  </div>  
    </Human>
    <hr></hr>
    <Crumb mdxType="Crumb">05. Architecture case study - pprmnt.cc</Crumb>
    <h3>{`Tooling`}</h3>
    <Steps mdxType="Steps">
      <ul>
        <li parentName="ul"><a parentName="li" {...{
            "href": "https://lame.sourceforge.io/"
          }}><inlineCode parentName="a">{`libmp3lame`}</inlineCode></a>{` a classic C library for encoding audio to MP3`}</li>
        <li parentName="ul"><a parentName="li" {...{
            "href": "https://emscripten.org/"
          }}><inlineCode parentName="a">{`emscripten`}</inlineCode></a>{` is used to compile `}<inlineCode parentName="li">{`libmp3lame`}</inlineCode>{` and C code to Web Assembly.`}</li>
        <li parentName="ul"><inlineCode parentName="li">{`Docker`}</inlineCode>{` - All the emscripten web assembly compilation is done in docker for better portability.`}</li>
        <li parentName="ul">{`Frontend offloads the web assembly operations to `}<a parentName="li" {...{
            "href": "https://developer.mozilla.org/en-US/docs/Web/API/Worker/Worker"
          }}>{`web workers`}</a>{` for better performance.`}</li>
        <li parentName="ul">{`Most of the frontend is actually just a React PWA`}</li>
      </ul>
    </Steps>
    <hr></hr>
    <Crumb mdxType="Crumb">05. Architecture case study - pprmnt.cc</Crumb>
    <h2>{`Build Sequence`}</h2>
    <Image src={buildSequence} style={{
      maxWidth: '1200',
      maxHeight: '600px',
      height: '455px',
      backgroundSize: 'contain',
      backgroundPosition: 'left'
    }} mdxType="Image" />
    <hr></hr>
    <Crumb mdxType="Crumb">05. Architecture case study - pprmnt.cc</Crumb>
    <h2>{`Browser Sequence`}</h2>
    <Image src={browserSequence} style={{
      maxWidth: '1200px',
      maxHeight: '600px',
      height: '455px',
      backgroundSize: 'contain',
      backgroundPosition: 'left'
    }} mdxType="Image" />
    <hr></hr>
    <Crumb mdxType="Crumb">05. Architecture case study - pprmnt.cc</Crumb>
    <h2>{`My Experience`}</h2>
    <Steps mdxType="Steps">
      <ul>
        <li parentName="ul">{`Something I originally thought had to be done on backend could actually be done entirely in the browser`}</li>
        <li parentName="ul">{`Only required about 90 lines of C code`}</li>
        <li parentName="ul">{`Majority of the time was spent piping it all together -- workflow, build, architecture, non-blocking workers, etc.`}</li>
        <li parentName="ul">{`Reading the `}<inlineCode parentName="li">{`libmp3lame`}</inlineCode>{` library source was pretty interesting`}</li>
        <li parentName="ul">{`Emphasis: Normal web tech with WASM sprinkled on top as turbo-boosters.`}</li>
      </ul>
    </Steps>
    <hr></hr>
    <Crumb mdxType="Crumb">05. Architecture case study - pprmnt.cc</Crumb>
    <h2>{`Key Takeaways for Dumb People`}</h2>
    <ul>
      <li parentName="ul">{`It's a tool that lets you run native code on the web.`}</li>
      <li parentName="ul">{`You'll know when you need it.`}</li>
      <li parentName="ul">{`It's good for small, sharp tools.`}</li>
      <li parentName="ul">{`Typical things you would do in a browser or Javascript are not being replaced by WASM.`}</li>
      <li parentName="ul">{`Normal web tech with WASM sprinkled on top as turbo-boosters.`}</li>
    </ul>
    <hr></hr>
    <Crumb mdxType="Crumb">05. Architecture case study - pprmnt.cc</Crumb>
    <Human mdxType="Human">Web Assembly -- it's pretty cool.</Human>
    <hr></hr>
    <h2>{`The End`}</h2>
    <img src="https://media1.tenor.com/images/76ae1bb244e515bdc96a2c7b4a9e636f/tenor.gif?itemid=10557286" />
    <hr></hr>
    <h3>{`Resources + further learning`}</h3>
    <ul>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://emscripten.org/"
        }}>{`emscripten`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://squoosh.app/"
        }}>{`Squoosh codebase`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://itnext.io/build-ffmpeg-webassembly-version-ffmpeg-js-part-4-ffmpeg-js-v0-2-web-worker-and-libx264-d0596f1beb4e"
        }}>{`Blog Post - Emscripten + ffmpeg`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://developers.google.com/web/updates/2018/03/emscripting-a-c-library"
        }}>{`Blog Post - Converting a C library to WASM`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://www.youtube.com/watch?v=FQJrcX4Ae8A"
        }}>{`Talk - Advanced Web Assembly with Ben Smith`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://madewithwebassembly.com/"
        }}>{`Made with Web Assembly`}</a></li>
    </ul>
    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;